import { mergeStyleSets } from '@uifabric/merge-styles';
import * as theme from './../theme/colors';

const reviewListClassNames = (): { [key: string]: string } => mergeStyleSets({
  orderCard: {
    maxWidth: '120ch',
    width: '96vw'
  },
  orderHead: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 8,
    color: theme.textOnThemePrimary,
    backgroundColor: theme.themePrimary
  },
  orderBody: {
    padding: '4ch 4ch 9ch 4ch',
    display: 'flex',
    justifyContent: 'space-between'
  },
  orderInfo: {
    flexGrow: 2,
    minHeight: '12ch',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    selectors: {
      '&>div': {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }
  },
  orderTotal: {
    fontWeight: 'bold',
    flexGrow: 1,
    alignItems: 'flex-end'
  },
  orderAction: {
    flexGrow: 1,
    paddingLeft: 12,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    selectors: {
      '&> *:not(:first-child)' : {
        marginTop: '3ch'
      },
      '.ms-Button-label': {
        whiteSpace: 'nowrap'
      }
    }
  },
  stack: {
    alignItems: 'center',
    selectors: {
      '&> div:not(:first-child)': {
        borderTop: '1px solid #ddd'
      },
      p: {
        maxWidth: '80ch'
      }
    }
  }});

export default reviewListClassNames;
